function voxelCountOfGrid(grid) {
    return grid.dimensions[0] * grid.dimensions[1] * grid.dimensions[2];
}
function maxEdgeOfGrid(grid) {
    return Math.max(...grid.dimensions);
}
function voxelGridWithinLimits(grid, limits) {
    const { maxEdge, maxVoxelCount } = limits ?? {};
    if (maxEdge > 0 && maxEdgeOfGrid(grid) > maxEdge) {
        return false;
    }
    if (maxVoxelCount > 0 && voxelCountOfGrid(grid) > maxVoxelCount) {
        return false;
    }
    return true;
}
export { voxelCountOfGrid as default, voxelCountOfGrid, maxEdgeOfGrid, voxelGridWithinLimits, };
